import {v4} from 'uuid'

export const getUUID = () => v4().replace(/[^\w\d]/g, '')
